import '@barev/ui/styles.css';
import './styles.css';
import './chats.css';
import './orders.css';
import './crm.css';
import './admin5.css';
import './moves.css';
import { ApiProvider, loadTextOverrides, ToastProvider } from '@barev/web';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { BoI18nProvider } from './i18n.tsx';

// названия услуг и другие тексты, изменённые в «Продуктах»
void loadTextOverrides();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApiProvider withCredentials>
      <BoI18nProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BoI18nProvider>
    </ApiProvider>
  </StrictMode>,
);
